import React from 'react';

const LokiStepContainer = ({ children }) => (
    <ol className="LokiSteps">
        {children}
    </ol>
);

export default LokiStepContainer;


// WEBPACK FOOTER //
// ./src/LokiStepContainer.js